import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EnrolledEmployeesColumn extends Column {
    title = 'time-off-v3.types-and-policies-table.enrolledEmployeesColumn';
    type: CellDisplay = CellDisplay.string;

    constructor(private hasTimeOffImprovement: boolean) {
        super();
    }

    getDisplayPropertyValue(timeOffPolicy: TimeOffPolicy): string {
        return this.hasTimeOffImprovement
            ? (timeOffPolicy.employeeCount + timeOffPolicy.futureEmployeeCount).toString()
            : timeOffPolicy.employeeCount.toString();
    }
}
